import React, { Fragment } from "react";
import Flatpickr from "react-flatpickr";
import { Czech } from 'flatpickr/dist/l10n/cs.js';
import "flatpickr/dist/themes/light.css";
import "../../assets/scss/plugins/forms/flatpickr/flatpickr.scss"
import moment from 'moment'


function makeid (length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
 }

export default class DateTime extends React.Component {
    flatpickrRef = null;

    state = {
        id: this.props.id ? this.props.id : "date-time-"+makeid(16),
        className: this.props.className ? this.props.className : "",
        defaultValue: this.props.defaultValue ? this.props.defaultValue : null,
        allowInput: this.props.allowInput ? this.props.allowInput : true,
        //disabled: this.props.disabled && this.props.disabled === true ? true : false,
        name: this.props.name ? this.props.name : "",
        style: this.props.style ? this.props.style : {},
        value: this.props.value ? this.props.value : null,
        options: this.props.options ? this.props.options  : {},
    } 

    componentDidMount () {

    }

    componentDidUpdate(prevProps, nextProps) {
        if (this.props.value !== prevProps.value) this.setState({ value: this.props.value });
    }
        
    handleOnChange = async (date) => {
        if (!Array.isArray(date)) date = [date];
        date[0] = moment(date[0]).format("YYYY-MM-DDTHH:mm:ss");
        if (date[1]) date[1] = moment(date[1]).format("YYYY-MM-DDTHH:mm:ss");
        if (this.props.onChange) this.props.onChange(date);
    }

    open = () => {
        if (this.flatpickrRef) this.flatpickrRef.flatpickr.open();   
    }

    render() {
        let options = this.state.options;
        options.locale = (moment.locale() == 'cs' ? Czech : {})

        return (
            <Fragment>
                {this.props.disabled
                    ? this.state.value ? <span className='font-weight-bold'>{this.state.value}</span> : ''
                    :
                        <Flatpickr
                            ref={(ref) => this.flatpickrRef = ref}
                            id={this.state.id}
                            className={this.state.className}
                            style={this.state.style}
                            name={this.state.name}
                            allowInput={this.state.allowInput}
                            disable={this.props.disabled && this.props.disabled === true ? true : false}
                            defaultValue={this.state.defaultValue}
                            value={this.state.value}
                            onChange={date => this.handleOnChange(date) }
                            options={options}
                        />
                }
            </Fragment>
        )
    }
}